let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eYDbq")).then(() => parcelRequire('i2ikM'));